/* eslint-disable implicit-arrow-linebreak */
import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {getAttachmentLimitPerGroup} from 'ag-common/tools/nachweisTypConstants'
import {nachweisHasEmptyTaetigkeit} from 'ag-common/tools/empty'
import Upload from '#components/a/form/Upload'

function AddTaetigkeitButton({
  gruppe,
  nachweis,
  nachweisTyp,
  handleAddTaetigkeit,
  handleUploadFile,
  isNewNachweis,
  disableAddTaetigkeit,
}) {
  const attachmentLimitReachedInGroup = () => {
    if (!nachweis || !nachweis.anhaenge) {
      return false
    }
    const filtered = nachweis.anhaenge.filter(file => file.gruppe === gruppe.index)
    if (filtered.length >= getAttachmentLimitPerGroup(nachweisTyp)) {
      return true
    }
    return false
  }
  const addTaetigkeitForGruppe = () => handleAddTaetigkeit(gruppe.index)
  const disabledAddTaetigkeit = nachweisHasEmptyTaetigkeit(nachweis, gruppe.index) || disableAddTaetigkeit
  const disabledUploadFile = attachmentLimitReachedInGroup()

  const buttonModifier = disabledUploadFile ? 'disabled' : 'attachment'
  return (
    <div className="addTaetigkeitButton__container" key={`addtaetigkeit-${gruppe.index}`}>
      <button
        type="button"
        id="ausbildungsNachweisHandleAddTaetigkeitenButton"
        className="addTaetigkeitButton"
        disabled={disabledAddTaetigkeit}
        onClick={addTaetigkeitForGruppe}
      >
        {i18n.t('nachweiseedit_addtaetigkeit_label')}
      </button>
      {!isNewNachweis && (
        <Upload
          onChangeHandle={e => handleUploadFile(e, gruppe.index)}
          accept="image/jpeg, image/png, application/pdf"
          isUploading={false}
          modifier={buttonModifier}
          disabled={disabledUploadFile}
        />
      )}
    </div>
  )
}

AddTaetigkeitButton.propTypes = {
  gruppe: PropTypes.shape({
    index: PropTypes.string,
  }),
  nachweis: PropTypes.object,
  nachweisTyp: PropTypes.string,
  handleAddTaetigkeit: PropTypes.func,
  handleUploadFile: PropTypes.func,
  isNewNachweis: PropTypes.bool,
  disableAddTaetigkeit: PropTypes.bool,
}

export default AddTaetigkeitButton
